/* eslint no-unused-vars: "off" */
import React from 'react';
import SuperHero from '../Hero/SuperHero';

export default function BuyerLandingHero() {
  const fal = false;
  const tru = true;
  return (
    <div>
      <SuperHero useXandr={tru} isMobileDevice={fal} />
    </div>
  );
}
